import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";
import { AntDesign } from "@expo/vector-icons";
import { userProfile } from "../action/authAction";
import { apiservice } from "../service";
import { useRecoilState } from "recoil";
import { tokenState, userState } from "../reducer/recoil";
import { styles, stylesResponsive } from "./style/background";
const { width, height } = Dimensions.get("window");

export default function background({ Title, admin, navigation }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [profile, setProfile] = useRecoilState(userState);
  async function userProfile() {
    try {
      const response = await apiservice({
        path: "/user",
        method: "get",
        token: token.token,
      });
      if (response.status == 200) {
        setProfile(response.data);
      }
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    userProfile();
  }, [token]);

  if (profile.profile == undefined) {
    return <View />;
  }

  // console.log("profile", profile.profile.Association.Country.country_name);
  // console.log(profile !== undefined && profile.profile.Association.Country);
  return (
    <View>
      <View style={styles.viewBackground}>
        {width < 1280 && (
          <TouchableOpacity
            onPress={() => {
              navigation.openDrawer();
            }}
            style={{ position: "absolute", paddingHorizontal: width * 0.04 }}
          >
            <AntDesign name="menu-fold" size={24} color="#2B6AB1" />
          </TouchableOpacity>
        )}
        {admin ? (
          <Text style={styles.textBackground}>{"ADMIN"}</Text>
        ) : (
          token !== "" &&
          profile.role == "User" && (
            <Text style={styles.textBackground}>
              {profile.profile.Association.Country.country_name}
            </Text>
          )
        )}
        {token !== "" && profile.profile.role == "User" && (
          <Text style={styles.textBackground}>
            {profile.profile.Association.Country.country_name}
          </Text>
        )}
        {token == "" && <Text style={styles.textBackground}>GUEST</Text>}
      </View>
      <View
        style={width < 1280 ? stylesResponsive.viewTitle : styles.viewTitle}
      >
        <Text
          style={width < 1600 ? stylesResponsive.textTitle : styles.textTitle}
        >
          {Title}
        </Text>
      </View>
    </View>
  );
}
